import { useState } from "react";
import { endingTabs } from "@/mocks/content";
import { Reveal, SectionHeading } from "./common";

export default function Ending() {
  const [active, setActive] = useState(endingTabs[0].key);
  const current = endingTabs.find((tab) => tab.key === active) ?? endingTabs[0];

  return (
    <section id="ending" className="section-anchor w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 max-w-7xl mx-auto">
        <Reveal>
          <SectionHeading
            eyebrow="结局解析"
            title="大结局：克制地收束，而不是激烈地审判"
            desc="关于善良的嫂子大结局，最值得讨论的不是「发生了什么」，而是人物在最后选择了怎样面对。下面从三个角度分别拆解。"
          />
        </Reveal>

        <Reveal delay={80}>
          <div className="mt-8 inline-flex flex-wrap gap-1 p-1 rounded-full bg-background-50 border border-background-200">
            {endingTabs.map((tab) => (
              <button
                key={tab.key}
                type="button"
                onClick={() => setActive(tab.key)}
                aria-pressed={active === tab.key}
                className={`px-4 md:px-6 py-2 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  active === tab.key
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:text-primary-600"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div className="mt-6 grid lg:grid-cols-3 gap-6 lg:gap-10 rounded-lg bg-background-50 border border-background-200 p-5 md:p-8">
            <div className="lg:col-span-2">
              <h3 className="font-heading text-lg md:text-2xl font-semibold text-foreground-950">
                {current.headline}
              </h3>
              <div className="mt-4 space-y-4">
                {current.paragraphs.map((p) => (
                  <p key={p.slice(0, 12)} className="text-sm md:text-base text-foreground-700 leading-relaxed">
                    {p}
                  </p>
                ))}
              </div>
            </div>
            <div className="rounded-lg bg-primary-50 border border-primary-200 p-4 md:p-5 h-fit">
              <h4 className="font-heading text-sm md:text-base font-semibold text-primary-800 flex items-center gap-2">
                <i className="ri-list-check-2"></i> 要点速记
              </h4>
              <ul className="mt-3 space-y-3">
                {current.points.map((point) => (
                  <li key={point} className="flex items-start gap-2 text-xs md:text-sm text-foreground-700 leading-relaxed">
                    <i className="ri-checkbox-circle-line text-primary-500 mt-0.5 shrink-0"></i>
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Reveal>

        <Reveal delay={160}>
          <div className="mt-6 flex flex-col md:flex-row items-start md:items-center gap-3 md:gap-4 rounded-lg bg-secondary-50 border border-secondary-200 p-4 md:p-5">
            <span className="service-icon-wrap shrink-0 rounded-md bg-secondary-500 text-background-50 flex items-center justify-center">
              <i className="ri-information-line text-xl"></i>
            </span>
            <p className="text-xs md:text-sm text-secondary-900 leading-relaxed">
              提醒：本页包含对结局与关键情节的讨论，属于剧透内容。不同观众对结尾的理解可能不同，本页力求呈现多种合理读法，而非给出唯一答案。
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}